module.exports = __webpack_public_path__ + "static/media/Hotel-Weinegg-Wellviva.c2c47824.jpg";